import { addCalendarDaysISO } from './date-range-calendar'

export type HostDayState = 'reserved' | 'blocked'

export function datesInRangeISO(start: string, end: string): string[] {
  const dates: string[] = []
  for (let day = start; day <= end; day = addCalendarDaysISO(day, 1)) dates.push(day)
  return dates
}

/** A reservation always wins, regardless of RPC row order. */
export function indexHostCalendar(
  ranges: readonly { startDate: string; endDate: string; reason: string }[],
) {
  const days = new Map<string, HostDayState>()
  for (const range of ranges) {
    // Guest calendars may rent a partial pickup/return day. This host action
    // blocks WHOLE days, so changeover edges belong to the reservation too.
    const isReservation = range.reason === 'reserved' || range.reason === 'changeover'
    for (const day of datesInRangeISO(range.startDate, range.endDate)) {
      if (days.get(day) !== 'reserved') days.set(day, isReservation ? 'reserved' : 'blocked')
    }
  }
  return days
}

/** Fetch the WHOLE selection, including intermediate months, not just the visible month. */
export function hostCalendarQueryWindow(
  monthStart: string,
  monthEnd: string,
  start: string | null,
  end: string | null,
) {
  return {
    from: start && start < monthStart ? start : monthStart,
    to: end && end > monthEnd ? end : monthEnd,
  }
}

export function firstReservedInRange(
  start: string,
  end: string,
  days: ReadonlyMap<string, HostDayState>,
): string | undefined {
  return datesInRangeISO(start, end).find((day) => days.get(day) === 'reserved')
}

export function groupContiguousDates(dates: string[]) {
  const ranges: Array<{ startDate: string; endDate: string }> = []
  for (const date of [...new Set(dates)].sort()) {
    const last = ranges.at(-1)
    if (last && addCalendarDaysISO(last.endDate, 1) === date) last.endDate = date
    else ranges.push({ startDate: date, endDate: date })
  }
  return ranges
}
